// extracted by mini-css-extract-plugin
export var breadcrumbs = "screen1-module--breadcrumbs--ca855";
export var btn = "screen1-module--btn--98f91";
export var content = "screen1-module--content--539c5";
export var screen1 = "screen1-module--screen1--7f18a";
export var title = "screen1-module--title--d8941";